import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { mediaManagerAtom, type IMediaManagerAtom } from '../atom';

export function useMediaManagerService() {
  const [config, setConfig] = useAtom(mediaManagerAtom);

  const openMediaManager = useCallback(
    (cfg: IMediaManagerAtom) => {
      setConfig(cfg);
    },
    [setConfig],
  );

  const closeMediaManager = useCallback(() => {
    setConfig(null);
  }, [setConfig]);

  return { config, openMediaManager, closeMediaManager };
}
